import React, { useState } from 'react';
import { ProjectsContainer, ProjectsH1, ProjectsTimeLine, ProjectsYear, ProjectsYearSpan, ProjectsBody } from './ProjectsElements';
import { FaAngleDoubleRight, FaAngleDoubleLeft } from 'react-icons/fa';
import { SliderProjects } from './SliderData';

const Projects = ( { slides } ) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const length = slides.length;

    const prevSlide = () => {
        setCurrentSlide(currentSlide === 0 ? length - 1 : currentSlide - 1);
    }

    const nextSlide = () => {
        setCurrentSlide(currentSlide === length - 1 ? 0 : currentSlide + 1);
    }

    if(!Array.isArray(slides) || slides.length <= 0) {
        return null;
    }

    return (
        <ProjectsContainer id="projects">
            <ProjectsH1>Projekty Stowarzyszenia</ProjectsH1>
            <ProjectsTimeLine>
                <FaAngleDoubleLeft onClick={prevSlide} className="left-arrow" />
                    {SliderProjects.map((slide, index) => {
                        return (
                            <div className={index === currentSlide ? 'year acitve' : 'year inactive'} key={index}>
                                {index === currentSlide && (
                                    <ProjectsYear>
                                        <ProjectsYearSpan>{slide.year}</ProjectsYearSpan>
                                    </ProjectsYear>
                                )}
                            </div>
                        )
                    })}
                    <FaAngleDoubleRight onClick={nextSlide} className="right-arrow"  />
            </ProjectsTimeLine>
            <ProjectsBody className="slider">
                {SliderProjects.map((slide, index) => {
                    return (
                        <div className={index === currentSlide ? 'slide active' : 'slide inactive'} key={index}>
                            {index === currentSlide && (
                                <div className="projectsContainer" id="projectsContainer">
                                        {typeof(slide.project1) === 'object' && slide.project1 !== null ? slide.project1.map((projectName, index2) => {
                                            return (<a target="_self" href={projectName.projectLink} className="projectGrid">
                                                        <span>
                                                            {projectName.projectName}
                                                        </span>
                                                    </a>
                                            );
                                        }) : null}
                                        {typeof(slide.project2) === 'object' && slide.project2 !== null ? slide.project2.map((projectName, index2) => {
                                            return (<a target="_self" href={projectName.projectLink} className="projectGrid">
                                                        <span>
                                                            {projectName.projectName}
                                                        </span>
                                                    </a>
                                            );
                                        }) : null}
                                        {typeof(slide.project3) === 'object' && slide.project3 !== null ? slide.project3.map((projectName, index2) => {
                                            return (<a target="_self" href={projectName.projectLink} className="projectGrid">
                                                        <span>
                                                            {projectName.projectName}
                                                        </span>
                                                    </a>
                                            );
                                        }) : null}
                                        {typeof(slide.project4) === 'object' && slide.project4 !== null ? slide.project4.map((projectName, index2) => {
                                            return (<a target="_self" href={projectName.projectLink} className="projectGrid">
                                                        <span>
                                                            {projectName.projectName}
                                                        </span>
                                                    </a>
                                            );
                                        }) : null}
                                        {typeof(slide.project5) === 'object' && slide.project5 !== null ? slide.project5.map((projectName, index2) => {
                                            return (<a target="_self" href={projectName.projectLink} className="projectGrid">
                                                        <span>
                                                            {projectName.projectName}
                                                        </span>
                                                    </a>
                                            );
                                        }) : null}
                                        {typeof(slide.project6) === 'object' && slide.project6 !== null ? slide.project6.map((projectName, index2) => {
                                            return (<a target="_self" href={projectName.projectLink} className="projectGrid">
                                                        <span>
                                                            {projectName.projectName}
                                                        </span>
                                                    </a>
                                            );
                                        }) : null}
                                        {typeof(slide.project7) === 'object' && slide.project7 !== null ? slide.project7.map((projectName, index2) => {
                                            return (<a target="_self" href={projectName.projectLink} className="projectGrid">
                                                        <span>
                                                            {projectName.projectName}
                                                        </span>
                                                    </a>
                                            );
                                        }) : null}
                                        {typeof(slide.project8) === 'object' && slide.project8 !== null ? slide.project8.map((projectName, index2) => {
                                            return (<a target="_self" href={projectName.projectLink} className="projectGrid">
                                                        <span>
                                                            {projectName.projectName}
                                                        </span>
                                                    </a>
                                            );
                                        }) : null}
                                        {typeof(slide.project9) === 'object' && slide.project9 !== null ? slide.project9.map((projectName, index2) => {
                                            return (<a target="_self" href={projectName.projectLink} className="projectGrid">
                                                        <span>
                                                            {projectName.projectName}
                                                        </span>
                                                    </a>
                                            );
                                        }) : null}
                                        {typeof(slide.project10) === 'object' && slide.project10 !== null ? slide.project10.map((projectName, index2) => {
                                            return (<a target="_self" href={projectName.projectLink} className="projectGrid">
                                                        <span>
                                                            {projectName.projectName}
                                                        </span>
                                                    </a>
                                            );
                                        }) : null}
                                        {typeof(slide.project11) === 'object' && slide.project11 !== null ? slide.project11.map((projectName, index2) => {
                                            return (<a target="_self" href={projectName.projectLink} className="projectGrid">
                                                        <span>
                                                            {projectName.projectName}
                                                        </span>
                                                    </a>
                                            );
                                        }) : null}
                                        {typeof(slide.project12) === 'object' && slide.project12 !== null ? slide.project12.map((projectName, index2) => {
                                            return (<a target="_self" href={projectName.projectLink} className="projectGrid">
                                                        <span>
                                                            {projectName.projectName}
                                                        </span>
                                                    </a>
                                            );
                                        }) : null}
                                </div>
                            )}
                        </div>
                    )
                })}
            </ProjectsBody>
        </ProjectsContainer>
    )
}

export default Projects
